// extracted by mini-css-extract-plugin
export default {"SignIN":"auth_SignIN__G3SaH","Peer":"auth_Peer__50ETm","Peer-first:hidden":"auth_Peer-first-hidden__9A1Cm"};